<template>
	<div class="container">

		<!-- Loading加载 -->
		<div class="loading" v-if="isDetail">
			<van-loading size="40px" type="spinner" color="#39CCCD" vertical>
				<div class="loading-text">
					<div>页面正在加载</div>
					<div>请稍候</div>
				</div>
			</van-loading>
		</div>

		<div v-show="!isDetail" class="content">

		</div>
	</div>
</template>

<script>
var that;
import { Toast } from 'vant';
export default {
	name: 'scanWXcode',
	components: {},
	props: {},
	data() {
		return {
			isDetail: true,
			code: '',
			token: '',
			key: ''
		}
	},
	created() {
		that = this;
		that.key = this.$route.query.key || '';

		const queryObj = that.getQueryObj();
		that.code = queryObj['code'] || that.code;
		if (that.code) {//拿到code后调用登录
			that.getLogin()
		} else {
			that.getWxInfo()
		}
		setTimeout(() => {
			that.isDetail = false;
		}, 500);
	},
	methods: {
		getLogin() {
			this.$http.get('/u/app/login/mpLogin', {
				code: that.code
			}).then(res => {
				console.log("token", res.data)
				localStorage.setItem('token', res.data)
				that.$router.push({
					path: '/app/success',
					query: { key: that.key }
				})
			}).catch(err => {
				//登录失效，清除token
				that.$toast('登录已失效,请退出再试')
				localStorage.removeItem('token')
				that.token = "";
			})
		},

		//授权
		getWxInfo() {
			Toast.loading({
				message: '加载中',
				forbidClick: true,
				loadingType: 'circular'
			});
			console.log('获取vx授权code')
			window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href + '#' + new Date().getTime())}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
		}, 

		getQueryObj() {
			var query = location.search
			var queryObj = {}
			var arr = query.slice(1, query.length).split('&')
			arr.forEach(function (val) {
				var arr1 = val.split('=')
				queryObj[arr1[0]] = arr1[1]
			})

			return queryObj
		},

	}
}
</script>

<style scoped lang="less">
.content {
	width: 100%;
	height: 100%;
}

.loading {
	margin: 40vh auto;
	text-align: center;

	.loading-text {
		color: #39CCCD;
		font-weight: bold;
	}
}
</style>